import { Table } from "react-bootstrap";
import CreatableSelect from "react-select/creatable";
import React, { Component } from "react";
import { CircularProgress } from "@material-ui/core";
import db, { storage } from "../firebase";
import { notify } from "react-notify-toast";
import Select from "react-select";
import { LinearProgress } from "material-ui";

export default class ProductBulkUpload extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: JSON.parse(localStorage.getItem("Ubytes")),
      products: [
        {
          productName: "",
          productPrice: 0,
          productDescription: "",
          tags: [],
          productImage: null,
        },
      ],
    };
  }
  componentDidMount() {
    if (this.state.user.role === "Superadmin") {
      this.loadMerchant();
    }
    if (this.state.user.role === "Merchant") {
      this.loadBranch();
    }
  }
  loadMerchant = async () => {
    let merchants = await db
      .collection("Merchant")

      .get();
    let mList = [];
    merchants.forEach((m) => {
      let _ = m.data();
      _["value"] = m.data().brandName;
      _["label"] = m.data().brandName;
      mList.push(_);
    });
    this.setState({ merchants: mList });
  };
  addProduct = () => {
    let payload = this.state.products;
    payload.push({
      productName: "",
      productPrice: 0,
      productDescription: "",
      tags: [],
      productImage: null,
    });
    this.setState({ products: payload });
  };
  imageUrl = (f) => {
    let url = URL.createObjectURL(f);
    console.log(url);
    return url;
  };
  updateContent = (info, index, label) => {
    let product = this.state.products;
    product[index][label] = info;
    this.setState({ products: product });
  };
  loadBranch = async () => {
    let user = this.state.user;
    let branches = await db
      .collection("Branches")
      .where(
        "of",
        "==",
        user.role === "Merchant" ? user.uid : this.state.selectedMerchant.uid
      )
      .get();
    let branchList = [];
    branches.forEach((branch) => {
      let _ = branch.data();
      _["value"] = branch.data().branchName;
      _["label"] = branch.data().branchName;
      branchList.push(_);
    });
    this.setState({ branches: branchList });
  };
  upload = async () => {
    this.setState({ loading: true });
    if (this.state.products.length <= 0) {
      notify.show("Please add some products", "warning");
      return;
    }

    await this.state.products.forEach(async (product, index) => {
      this.setState({ loading: true });
      let payload = product;
      let user = this.state.user;
      let taglist = [];
      console.log(product.tags);
      product.tags.forEach((tag) => {
        taglist.push(tag.value);
      });
      console.log(taglist);
      payload.tags = taglist;
      const image = payload.productImage;

      if (payload.productName === "" || payload.productPrice === 0) {
        notify.show(`Please fill data properly in ${index}th row`, "error");
        return;
      }
      if (user.role === "Merchant") {
        if (!this.state.selectedBranch) {
          notify.show("Please select a branch", "warning");
          return;
        }
        payload["of"] = this.state.selectedBranch.branchId;
        payload["ofMerchant"] = user.uid;
      } else if (user.role === "Branch") {
        payload["of"] = user.branchId;
        payload["ofMerchant"] = user.uid;
      } else if (user.role === "Superadmin") {
        if (!this.state.selectedBranch && !this.state.selectedMerchant) {
          notify.show(
            "Please select a branch and a merchant Properly",
            "warning"
          );
          return;
        }
        payload["of"] = this.state.selectedBranch.branchId;
        payload["ofMerchant"] = this.state.selectedMerchant.uid;
      }

      payload.productImage = "";
      console.log(payload);
      await db
        .collection("Products")
        .add(payload)
        .then(async (doc) => {
          const ref = storage.ref("productImage/" + doc.id);
          const url = await ref.put(image);
          const image_ = await url.ref.getDownloadURL();

          //console.log(this.state.loading);
          await doc.update({ productId: doc.id, productImage: image_ });
          this.setState({
            progress: (index / this.state.products.length) * 100,
          });

          notify.show(`${product.productName} updated successfully`, "success");
        });
    });

    this.setState({ loading: false });
  };
  enumerateTags = (tags) => {
    let tagList = [];
    tags.forEach((tag) => {
      tagList.push(tag.value);
    });
    return tagList;
  };
  deleteRow = (index) => {
    let payload = this.state.products;
    payload.pop(index);
    this.setState({ products: payload });
  };
  render() {
    return (
      <div className="productBulkUploadBody">
        <div className="bsc">
          {this.state.user.role === "Superadmin" ? (
            <>
              <Select
                placeholder="Select Merchant"
                options={this.state.merchants}
                onChange={(e) => this.setState({ selectedMerchant: e })}
                onBlur={() => this.loadBranch()}
              ></Select>
              <Select
                placeholder="Select Branch"
                options={this.state.branches}
                onChange={(e) => this.setState({ selectedBranch: e })}
              ></Select>
            </>
          ) : null}
          {this.state.user.role === "Merchant" ? (
            <Select
              placeholder="Select Branch"
              options={this.state.branches}
              onChange={(e) => this.setState({ selectedBranch: e })}
            ></Select>
          ) : null}
        </div>
        <Table striped bordered hover>
          <thead>
            <tr>
              <td>Id</td>
              <td>Product Name</td>
              <td>Product Description</td>

              <td>Product Price</td>
              <tb>Product Tag</tb>
              <td>Product Image</td>
              <td>Delete</td>
            </tr>
          </thead>
          <tbody>
            {this.state.products.map((prod, index) => {
              return (
                <tr key={prod.productId} className="product-bulk-rows">
                  <td>{index + 1}</td>
                  <td>
                    <input
                      value={prod.productName}
                      placeholder="Product Name"
                      onChange={(e) =>
                        this.updateContent(e.target.value, index, "productName")
                      }
                    ></input>
                  </td>
                  <td>
                    <input
                      value={prod.productDescription}
                      onChange={(e) =>
                        this.updateContent(
                          e.target.value,
                          index,
                          "productDescription"
                        )
                      }
                      placeholder="Product Description"
                    ></input>
                  </td>
                  <td>
                    <input
                      value={prod.productPrice}
                      type="number"
                      onChange={(e) =>
                        this.updateContent(
                          e.target.value,
                          index,
                          "productPrice"
                        )
                      }
                      placeholder="Price"
                    ></input>
                  </td>
                  <td>
                    <CreatableSelect
                      isMulti
                      isClearable
                      onChange={(e) => this.updateContent(e, index, "tags")}
                    ></CreatableSelect>
                  </td>
                  <td>
                    {prod.productImage ? (
                      <img
                        src={this.imageUrl(prod.productImage)}
                        style={{ width: "50px", height: "50px" }}
                      ></img>
                    ) : (
                      <input
                        type="file"
                        value={prod.productImage}
                        onChange={(e) =>
                          this.updateContent(
                            e.target.files[0],
                            index,
                            "productImage"
                          )
                        }
                      ></input>
                    )}
                  </td>
                  <td>
                    <button
                      style={{ backgroundColor: "tomato" }}
                      onClick={() => this.deleteRow(index)}
                    >
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
          </tbody>
        </Table>
        <button onClick={this.addProduct}>Add</button>

        {this.state.loading ? (
          <LinearProgress
            value={this.state.progress}
            variant="buffer"
          ></LinearProgress>
        ) : (
          <button onClick={this.upload}>Upload</button>
        )}
      </div>
    );
  }
}
